/* global jQuery COMPONENTS */

COMPONENTS.ComponentTimeline = (function ($) {
  function ComponentTimeline () {
    this.$component = $('[data-ecs-component="component-timeline"]')
    this.$sliderElems = this.$component.find('[data-ecs-component-control="timeline-slider"]')
    this.$buttonTabs = this.$component.find('[data-ecs-components-control="timeline-tabs"]')
    this.$eventButtons = this.$component.find('[data-ecs-control="timeline"]')
    this.$timelineBars = this.$component.find('[data-ecs-timeline-bar]')
    this.$timelineArrows = this.$component.find('[data-ecs-timeline-arrow]')
  }

  ComponentTimeline.prototype.refreshSliders = function (needle) {
    const $activeTab = $(`[data-tab="${needle}"]`)
    const $slider = $activeTab.find('[data-ecs-component-control="timeline-slider"]')
    $slider.slick('refresh')
  }

  ComponentTimeline.prototype.eventButtonChangeSlide = function (button, slider, slide) {
    const component = this
    const $slider = $(component.$sliderElems).filter('[data-ecs-slider="' + slider + '"]')

    $slider.slick('slickGoTo', (slide - 1), false)

    component.$eventButtons.each(function () {
      $(this).removeClass('ecs_active')
    })
    button.addClass('ecs_active')
  }

  ComponentTimeline.prototype.filledBarWidth = function (slider, targetSlide) {
    const component = this
    const timelineBar = $(component.$timelineBars).filter('[data-ecs-timeline-bar="' + slider + '"]')
    const eventCount = $(component.$eventButtons).filter('[data-ecs-timeline-slider="' + slider + '"]').length
    const eventWidthPercent = 100 / eventCount
    const barWidthPercent = (eventWidthPercent * targetSlide) - (eventWidthPercent / 2)

    $(timelineBar).css('width', (barWidthPercent + '%'))
  }

  ComponentTimeline.prototype.eventAutomaticSlide = function (slider, targetSlide) {
    const component = this
    const eventButton = component.$eventButtons.filter('[data-ecs-timeline-slider="' + slider + '"][data-ecs-timeline-slide-id="' + (targetSlide + 1) + '"]')

    component.$eventButtons.each(function () {
      $(this).removeClass('ecs_active')

      if ((targetSlide + 1) > $(this).data('ecs-timeline-slide-id')) {
        $(this).addClass('ecs_event_past')
      } else {
        $(this).removeClass('ecs_event_past')
      }
    })
    eventButton.addClass('ecs_active')
  }

  ComponentTimeline.prototype.init = function () {
    const component = this
    let accordion_index = 0

    component.$accordions = component.$component.find('[data-ecs-components-control="timeline-accordion"]')

    if (component.$accordions.length >= 1) {
      component.$accordions.accordion()
    }

    if (component.$sliderElems.length >= 1) {
      component.$sliderElems.each(function () {
        const utility = new COMPONENTS.Utility()
        const $slider = $(this)
        $slider.slidesToDisplay = ($slider.data('ecs-components-slide-count') ? $slider.data('ecs-components-slide-count') : 1)
        $slider.sliderVars = utility.getSliderVars(this.slidesToDisplay, null, false, true, false)

        $slider.slick($slider.sliderVars)

        // On after slide change
        $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
          const slider = $(this).data('ecs-slider')
          component.filledBarWidth(slider, (nextSlide + 1))
          component.eventAutomaticSlide(slider, nextSlide)
        })
      })
    }

    if (component.$sliderElems.length >= 1) {
      component.$eventButtons.each(function () {
        $(this).click(function () {
          const sliderNeedle = $(this).data('ecs-timeline-slider')
          const slideNeedle = $(this).data('ecs-timeline-slide-id')

          component.eventButtonChangeSlide($(this), sliderNeedle, slideNeedle)
        })
      })
    }

    if (component.$timelineArrows.length >= 1) {
      component.$timelineArrows.each(function () {
        $(this).click(function () {
          const sliderNeedle = $(this).data('ecs-timeline-slider')
          const $slider = $(component.$sliderElems).filter('[data-ecs-slider="' + sliderNeedle + '"]')
          const prevAttr = $(this).attr('data-ecs-timeline-arrow-previous')

          if (typeof prevAttr !== 'undefined' && prevAttr !== false) {
            $slider.slick('slickPrev')
          } else {
            $slider.slick('slickNext')
          }
        })
      })
    }

    if (component.$buttonTabs.length > 0 || (typeof (component.$selectTabs) !== 'undefined' && component.$selectTabs.length > 0)) {
      $('.menu .item').tab({
        onVisible: function () {
          component.refreshSliders($(this).data('tab'))
        }
      })
    }
  }

  return ComponentTimeline
})(jQuery)

document.addEventListener('components_init', function (e) {
  // Hook into the main components init
  COMPONENTS.componentTimeline = new COMPONENTS.ComponentTimeline()
  COMPONENTS.componentTimeline.init()
})
